// ***************************************************************
// ***                Auto Complete custom hooks               ***
// ***************************************************************

document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
      algoliaShopify.config.show_products = true; //ensure the results are distinct by plp title
      algoliaShopify.translations.collections = "Popular Categories";
      algoliaShopify.translations.articles = "Relevant Blogs";
      algoliaShopify.b2b = window.b2b;
      algoliaShopify.catalog = window.catalog;

      const screenWidth = window.innerWidth;
      if (screenWidth < 990) {
        const containerMobile = document.querySelector('#mobilesearch'); // Finds the first element with the ID 'mobilesearch'
        if (containerMobile) {
          containerMobile.innerHTML = '';
          const containerClasses = containerMobile.classList;
          containerClasses.add('aa-MainContainer');
          options.detachedMediaQuery = 'none';
          options.container = containerMobile;
        }
      }

      options.placeholder = "Search for over 20,000 products...";

      //Debounce
      function debouncePromise(func, time) {
        let timerId = undefined;
        return function debounced(...args) {
          if (timerId) {
            clearTimeout(timerId);
          }

          return new Promise((resolve) => {
            timerId = setTimeout(() => resolve(func, ...args), time);
          });
        };
      }

      const debounced = debouncePromise((items) => Promise.resolve(items), 300);
      options.getSources = function ({ query, setContext }) {
        return [
          {
            sourceId: "products",
            getItems() {
              return debounced(
                algoliaShopify.externals.getAlgoliaResults({
                  searchClient: algoliaShopify.searchClient,
                  queries: [
                    {
                      indexName: `${algoliaShopify.config.index_prefix}products`,
                      params: {
                        query,
                        hitsPerPage: 5,
                      },
                    },
                  ], 
                })
              );
            },
            templates: {
              noResults(templateOptions) {
                const { html, state } = templateOptions;
                return html`<div class="aa-PanelLayout aa-Panel--scrollable">
                          <p class="aa-NoResultsHeader">
                            ${algoliaShopify.translation_helpers.no_result_for(state.query)}
                          </p>
                          <a class="aa-NoResultsLink" href="${window.Shopify.routes.root}search?q=">
                            ${algoliaShopify.translations.allProducts}
                          </a>
                        </div>`;
              },
              item({ item, html }) {
                var hitPriceData = priceData(item);
                const variantInfo = item.objectID !== item.id ? `?variant=${item.objectID}` : '';
                var itemHandle = item.handle; 
                if (item.meta && item.meta.product && item.meta.product.canonical) {
                  itemHandle = item.meta.product.canonical
                }
                const vpItemLink = `/products/${itemHandle}${variantInfo}`; 
                
                return html`<a
                          href="${vpItemLink}"
                          class="aa-ItemLink aa-ProductItem"
                          onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"
                        >
                          <div class="aa-ItemContent">
                            <div class="aa-ItemPicture aa-ItemPicture--loaded">
                              <img
                                src="${algoliaShopify.helpers.compactImage(item)}"
                                alt="${plpTitle(item)}"
                              />
                              <div class="card__content">
                                <div class="card__badge top left">
                                  ${item.inventory_available > 0 || item.inventory_policy === 'continue' || item.product_type === "Gift Cards"?
                                    algoliaShopify.b2b ?
                                          hitPriceData.clearance && html`<span class="badge aa-badge badge--bottom-left color-clearance-badge">Clearance</span>`
                                        : displayCustomSalesBadge(item.meta.product ? item.meta.product.sale_badge_text : '', item.meta.product ? item.meta.product.sale_start_date : '', item.meta.product ? item.meta.product.sale_end_date : '') && item.compare_at_price > item.price && item.meta.product.display_both_sale_badges === true ?
                                            html`<span class="badge aa-badge badge--bottom-left color-{{ settings.sale_badge_color_scheme }}">Sale</span><span class="badge aa-badge badge--bottom-left color-custom-sale-badge">${ item.meta.product.sale_badge_text }</span>`
                                            : displayCustomSalesBadge(item.meta.product ? item.meta.product.sale_badge_text : '', item.meta.product ? item.meta.product.sale_start_date : '', item.meta.product ? item.meta.product.sale_end_date : '') ?
                                                html`<span class="badge aa-badge badge--bottom-left color-custom-sale-badge">${ item.meta.product.sale_badge_text }</span>`
                                                : item.compare_at_price > item.price && (item.meta.product.obsolete == true || item.meta.product.obsolete == 'true') && html`<span class="badge aa-badge badge--bottom-left color-clearance-badge">Clearance</span>`
                                      : html`<span class="badge aa-badge badge--bottom-left color-inverse">${ algoliaShopify.translations.outOfStock }</span>`}
                                  </div>
                              </div>
                            </div>
                            <div class="aa-ItemContentBody">
                              <div class="aa-ItemContentTitleWrapper">
                                <div class="aa-ItemContentTitle">
                                  ${plpTitle(item)}
                                </div>
                              </div>
                              <div class="aa-ItemContentPrice">
                                <div class="aa-ItemContentPriceCurrent">${hitPriceData.display_compare_at_price ? 
                                  html`<span class="aa-ItemContentPriceStrike">${hitPriceData.display_compare_at_price_formatted}</span> <span class="${hitPriceData.catalog_price ? html`aa-ItemContentPriceB2B`: html`aa-ItemContentPriceSale`}">${hitPriceData.display_price_formatted}</span>`
                                  :html`<span class="${hitPriceData.catalog_price ? html`aa-ItemContentPriceB2B`: html``}">${hitPriceData.display_price_formatted}</span>`}
                                </div>
                              </div>
                              ${algoliaShopify.b2b 
                                && hitPriceData.display_compare_at_price 
                                && html`<div class="aa-ItemContentPrice">
                                <div class="aa-ItemContentPriceCurrent"><span style="color:rgb(136, 136, 136);font-weight:600;line-height:normal"> Margin: ${hitPriceData.margin_formatted}</span></div>
                                </div>`}
                            </div>
                          </div>
                        </a>`;
              },
              header(templateOptions) {
                const { html, state } = templateOptions;
                return html`
                  <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle">
                      ${algoliaShopify.translation_helpers.render_title(
                        'Products',
                        state.query
                      )}
                    </span>
                    <div class="aa-SourceHeaderLine" />
                  </div>
                `;
              },
              footer(templateOptions) {
                const { html, state } = templateOptions;
                return html`
                  <div class="aa-footer">
                    <a
                      class="aa-SeeAllBtn"
                      href="${window.Shopify.routes.root}search?q=${state.query}"
                    >
                      ${algoliaShopify.translations.allProducts}
                      (${algoliaShopify.helpers.formatNumber(state.context.nbProducts)})
                    </a>
                  </div>
                `;
              }
            },
          },
        ];
      };

      return options;
    });

    algoliaShopify.hooks.registerHook('beforeAutocompleteFiltersString', function(_defaultFilter) {
      // Don't return the default filter and return a custom filter
      algoliaShopify.b2b = window.b2b;
      algoliaShopify.catalog = window.catalog;
      
      let modifiedFilter = '';
      if (algoliaShopify.config.stock_policy === 'deny') {
          // For 'deny' we will filter out all items based on inventory quantity
          modifiedFilter = 'inventory_quantity > 0';
        } else if (algoliaShopify.config.stock_policy === 'continue') {
          /**
           * For 'continue' we will filter on `inventory_available` attribute whose
           * value is dependent on:
           * `inventory_quantity > 0 OR inventory_policy == 'continue'`
           */
          modifiedFilter = 'inventory_available:true';
        }

        // Filter to exclude products that should not be shown for a customer's catalog value
        modifiedFilter += modifiedFilter.length > 0 ? " AND " : "";
        modifiedFilter += `NOT "named_tags.Exclude Customer":"${algoliaShopify.catalog}"`;
        return modifiedFilter; //`NOT "named_tags.Exclude Customer":"retail"`;
    });

    algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
        const { html } = templateOptions;
        // Don't return the default template and return a custom two-column layout instead
        return html`
          <div class="aa-PanelLayout aa-Panel--scrollable">
            <div class="aa-PanelSections">
              <div class="aa-PanelSection--left">
                ${displaySuggestions &&
                  html`
                    <div class="aa-SourceHeader">
                      <span class="aa-SourceHeaderTitle"
                        >${algoliaShopify.translations.suggestions}</span
                      >
                      <div class="aa-SourceHeaderLine" />
                    </div>
                    ${elements.querySuggestionsPlugin}
                  `}
                ${elements.collections} ${elements.articles} ${elements.pages}
                ${elements.redirectUrlPlugin}
              </div>
              <div class="aa-PanelSection--right">
                ${elements.products}
              </div>
            </div>
          </div>
        `;
    });

    algoliaShopify.hooks.registerHook('beforeAutocompleteMainProductsTemplate', function(_defaultTemplate, templateOptions, elements) {
        const { html } = templateOptions;
        return html`
          <div class="aa-PanelLayout aa-Panel--scrollable">
            <div class="aa-PanelSection">
              ${elements.products}
            </div>
          </div>
        `;
    });
});

// ***************************************************************
// ***               Instant Search custom hooks               ***
// ***************************************************************
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', function(options) {
    algoliaShopify.translations.relevance = "Recommended";
    algoliaShopify.translations.sortBy = "Sort By:"
    algoliaShopify.translations.showMore = "Show all";
    algoliaShopify.translations.outOfStock = "Sold Out";
    
    algoliaShopify.config.show_products = true; //ensure the results are distinct by plp title
    return options;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(options) {
    if (options && Array.isArray(options.sortOrders)) {
        options.sortOrders.forEach(order => {
            if (order.value === "mtbd_shopify_au_products") {
                order.label = "Recommended"; // Update the label
            }
        });
    }
    options.selector = "#algolia-shopify-instantsearch";

    algoliaShopify.config.show_products = true; //ensure the results are distinct by plp title

    // Loop through the facet widgets.
    const widgets = options.facets.widgets.map(widget => {
      // Only update the refinementList widget params.
      if (widget.name !== 'refinementList') {
        return widget;
      }

      // This updates all `refinementList` widgets.
      // If you only want to update specific facet(s),
      // you can target them by checking the value of `widget.params.container`. 
      return {
        ...widget,
        params: {
          ...widget.params,
          // limit: 10,
          // showMore: true,
        }
      }
    });

    return {
      ...options,
      facets: {
        ...options.facets,
        widgets
      }
    };
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchAllowParamsArray', function(allowParamsArray) {
    // Ensure the input is an array
    if (typeof allowParamsArray === 'string') {
      // Convert string to an array (e.g., split by commas or based on expected format)
      allowParamsArray = allowParamsArray.split(','); // Adjust the delimiter as needed
    }

    if (Array.isArray(allowParamsArray)) {
      // Modify the array
      allowParamsArray.push('q');
      allowParamsArray.push('ref');
      allowParamsArray.push('utm_medium');
      allowParamsArray.push('utm_campaign');
      allowParamsArray.push('_kx');
    } else {
      console.error('allowParamsArray is not an array and could not be processed.');
      return []; // Return an empty array or handle the error appropriately
    }
    
    return allowParamsArray;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function(defaultFilter) {
    // Modify or replace the default string, then return a string
    algoliaShopify.b2b = window.b2b;
    algoliaShopify.catalog = window.catalog;

    if(defaultFilter) {
      if (defaultFilter.includes("collection_ids")) {
        const collectionIDFilterRegex = /collection_ids:"\w+"/g;
        const matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
        const collectionHandle = (matches && matches.length === 2) ? matches[1] : null;

        if (collectionHandle) {
          defaultFilter = defaultFilter.replace(
            collectionIDFilterRegex, "collections:" + collectionHandle
          );
          //console.log('collectionHandle',collectionHandle, 'defaultFilter', defaultFilter);
        }
      }
      return defaultFilter + ` AND NOT "named_tags.Exclude Customer":"${algoliaShopify.catalog}"`;
    }
    else {
      return `NOT "named_tags.Exclude Customer":"${algoliaShopify.catalog}"`;
    }
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    const filterCount = (window.location.href.match(/refinementList/g) || []).length;
    const filterText = filterCount > 0 ? `Filters (${filterCount})` : "Filters";

    const sortBy = new URLSearchParams(window.location.search).get("sortBy") || "mtbd_shopify_au_products";

    const sortLabels = {
      mtbd_shopify_au_products: "Recommended",
      mtbd_shopify_au_products_recently_ordered_count_desc: "Best selling",
      mtbd_shopify_au_products_price_asc: "Price, Low to High",
      mtbd_shopify_au_products_price_desc: "Price, High to Low",
      mtbd_shopify_au_products_title_asc: "Name",
      mtbd_shopify_au_products_title_desc: "Name Z-A",
      mtbd_shopify_au_products_vendor_asc: "Brand",
      mtbd_shopify_au_products_vendor_desc: "Brand Z-A",
      mtbd_shopify_au_products_published_at_desc: "Newest first"
    };
    const sortLabel = sortLabels[sortBy] || "Recommended"; // Fallback to "Recommended"
  
    return html`
      <div class="ais-page">
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-button-container">
          <!-- Placeholder div required for Algolia -->
          <div class="ais-facets-button" style="display: none;"></div>

          <!-- Filters Button -->
          <div class="ais-button" onclick="${() => openCloseModalFacets()}">
            <span class="ais-button-filter-text">${filterText}</span>
            <svg viewBox="0 0 16 16" class="button-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.8 3.2H3.348C3.6792 4.1288 4.5584 4.8 5.6 4.8C6.6416 4.8 7.5208 4.1288 7.852 3.2H15.2C15.6424 3.2 16 2.8424 16 2.4C16 1.9576 15.6424 1.6 15.2 1.6H7.852C7.5208 0.6712 6.6416 0 5.6 0C4.5584 0 3.6792 0.6712 3.348 1.6H0.8C0.3576 1.6 0 1.9576 0 2.4C0 2.8424 0.3576 3.2 0.8 3.2ZM15.2 12.8H7.852C7.5208 11.8712 6.6416 11.2 5.6 11.2C4.5584 11.2 3.6792 11.8712 3.348 12.8H0.8C0.3576 12.8 0 13.1576 0 13.6C0 14.0424 0.3576 14.4 0.8 14.4H3.348C3.6792 15.3288 4.5584 16 5.6 16C6.6416 16 7.5208 15.3288 7.852 14.4H15.2C15.6424 14.4 16 14.0424 16 13.6C16 13.1576 15.6424 12.8 15.2 12.8ZM15.2 7.2H12.652C12.3208 6.2712 11.4416 5.6 10.4 5.6C9.3584 5.6 8.4792 6.2712 8.148 7.2H0.8C0.3576 7.2 0 7.5576 0 8C0 8.4424 0.3576 8.8 0.8 8.8H8.148C8.4792 9.7288 9.3584 10.4 10.4 10.4C11.4416 10.4 12.3208 9.7288 12.652 8.8H15.2C15.6424 8.8 16 8.4424 16 8C16 7.5576 15.6424 7.2 15.2 7.2ZM5.6 1.6C6.0416 1.6 6.4 1.9584 6.4 2.4C6.4 2.8416 6.0416 3.2 5.6 3.2C5.1584 3.2 4.8 2.8416 4.8 2.4C4.8 1.9584 5.1584 1.6 5.6 1.6ZM5.6 14.4C5.1584 14.4 4.8 14.0416 4.8 13.6C4.8 13.1584 5.1584 12.8 5.6 12.8C6.0416 12.8 6.4 13.1584 6.4 13.6C6.4 14.0416 6.0416 14.4 5.6 14.4ZM10.4 8.8C9.9584 8.8 9.6 8.4416 9.6 8C9.6 7.5584 9.9584 7.2 10.4 7.2C10.8416 7.2 11.2 7.5584 11.2 8C11.2 8.4416 10.8416 8.8 10.4 8.8Z" fill="#222222"></path><mask id="mask0_8095:39389" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16" class="__web-inspector-hide-shortcut__"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.8 3.2H3.348C3.6792 4.1288 4.5584 4.8 5.6 4.8C6.6416 4.8 7.5208 4.1288 7.852 3.2H15.2C15.6424 3.2 16 2.8424 16 2.4C16 1.9576 15.6424 1.6 15.2 1.6H7.852C7.5208 0.6712 6.6416 0 5.6 0C4.5584 0 3.6792 0.6712 3.348 1.6H0.8C0.3576 1.6 0 1.9576 0 2.4C0 2.8424 0.3576 3.2 0.8 3.2ZM15.2 12.8H7.852C7.5208 11.8712 6.6416 11.2 5.6 11.2C4.5584 11.2 3.6792 11.8712 3.348 12.8H0.8C0.3576 12.8 0 13.1576 0 13.6C0 14.0424 0.3576 14.4 0.8 14.4H3.348C3.6792 15.3288 4.5584 16 5.6 16C6.6416 16 7.5208 15.3288 7.852 14.4H15.2C15.6424 14.4 16 14.0424 16 13.6C16 13.1576 15.6424 12.8 15.2 12.8ZM15.2 7.2H12.652C12.3208 6.2712 11.4416 5.6 10.4 5.6C9.3584 5.6 8.4792 6.2712 8.148 7.2H0.8C0.3576 7.2 0 7.5576 0 8C0 8.4424 0.3576 8.8 0.8 8.8H8.148C8.4792 9.7288 9.3584 10.4 10.4 10.4C11.4416 10.4 12.3208 9.7288 12.652 8.8H15.2C15.6424 8.8 16 8.4424 16 8C16 7.5576 15.6424 7.2 15.2 7.2ZM5.6 1.6C6.0416 1.6 6.4 1.9584 6.4 2.4C6.4 2.8416 6.0416 3.2 5.6 3.2C5.1584 3.2 4.8 2.8416 4.8 2.4C4.8 1.9584 5.1584 1.6 5.6 1.6ZM5.6 14.4C5.1584 14.4 4.8 14.0416 4.8 13.6C4.8 13.1584 5.1584 12.8 5.6 12.8C6.0416 12.8 6.4 13.1584 6.4 13.6C6.4 14.0416 6.0416 14.4 5.6 14.4ZM10.4 8.8C9.9584 8.8 9.6 8.4416 9.6 8C9.6 7.5584 9.9584 7.2 10.4 7.2C10.8416 7.2 11.2 7.5584 11.2 8C11.2 8.4416 10.8416 8.8 10.4 8.8Z" fill="white"></path></mask><g mask="url(#mask0_8095:39389)"></g></svg>
          </div>

          <!-- Sort Button + Dropdown -->
          <div class="ais-button ais-sort-wrapper" style="border-left: none !important;">
            <div class="ais-sort-toggle" onclick="${() => toggleSortDropdown()}">
              <span class="ais-button-sortby-text">${sortLabel}</span>
              <svg class="sort-chevron" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>
            <div class="ais-sort-dropdown" hidden>
              <div class="ais-sort-option" data-value="mtbd_shopify_au_products" onclick="${() => sortOptionClicked('mtbd_shopify_au_products')}">Recommended</div>
              <div class="ais-sort-option" data-value="mtbd_shopify_au_products_recently_ordered_count_desc" onclick="${() => sortOptionClicked('mtbd_shopify_au_products_recently_ordered_count_desc')}">Best selling</div>
              <div class="ais-sort-option" data-value="mtbd_shopify_au_products_price_asc" onclick="${() => sortOptionClicked('mtbd_shopify_au_products_price_asc')}">Price, Low to High</div>
              <div class="ais-sort-option" data-value="mtbd_shopify_au_products_price_desc" onclick="${() => sortOptionClicked('mtbd_shopify_au_products_price_desc')}">Price, High to Low</div>
              <div class="ais-sort-option" data-value="mtbd_shopify_au_products_title_asc" onclick="${() => sortOptionClicked('mtbd_shopify_au_products_title_asc')}">Name</div>
              <div class="ais-sort-option" data-value="mtbd_shopify_au_products_title_desc" onclick="${() => sortOptionClicked('mtbd_shopify_au_products_title_desc')}">Name Z-A</div>
              <div class="ais-sort-option" data-value="mtbd_shopify_au_products_vendor_asc" onclick="${() => sortOptionClicked('mtbd_shopify_au_products_vendor_asc')}">Brand</div>
              <div class="ais-sort-option" data-value="mtbd_shopify_au_products_vendor_desc" onclick="${() => sortOptionClicked('mtbd_shopify_au_products_vendor_desc')}">Brand Z-A</div>
              <div class="ais-sort-option" data-value="mtbd_shopify_au_products_published_at_desc" onclick="${() => sortOptionClicked('mtbd_shopify_au_products_published_at_desc')}">Newest first</div>
            </div>
          </div>
        </div>

        <div class="ais-facets-modal-overlay" onclick="${() => openCloseModalFacets()}"></div>
        <div class="ais-facets">
          <div class="ais-facets-header">Filters</div>
          <div class="ais-facets-modal-heading">Filters<button class="close-button" type="button" aria-label="Close" onclick="${() => openCloseModalFacets()}">X</button></div>
          <div class="ais-current-refined-values-container">
          </div>
          <div class="ais-clear-refinements-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                  <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" checked/>
                  <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">
                    ${facet.title}
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>
                  </label>
                  <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
              <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
    
    var hitPriceData = priceData(hit);
    var has_rating = hit.meta.reviews && hit.meta.reviews.rating && JSON.parse(hit.meta.reviews.rating).value > 0 ? true : false;
    var isNewArrival = Array.isArray(hit.tags) && hit.tags.includes('New Arrival');
    var isLifetimeWarranty = Array.isArray(hit.tags) && hit.tags.includes('Lifetime Warranty');
    var isExclusive = Array.isArray(hit.tags) && hit.tags.includes('Exclusive');
    var isTeamsPick = Array.isArray(hit.tags) && hit.tags.includes('Teams Pick');
    var isBestSeller = Array.isArray(hit.tags) && hit.tags.includes('Best Seller');
    const customBadges = {
      1: null,
      2: null,
      3: null,
      4: null,
      5: null
    };

    if (typeof hit.named_tags === 'object' && hit.named_tags !== null) {
      for (let i = 1; i <= 5; i++) {
        const key = `Custom Badge ${i}`;
        const value = hit.named_tags[key];
        customBadges[i] = value && value.trim() !== "" ? value.trim() : null;
      }
    }

    return html`<div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${canonicalHandle(hit)}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
      >
        <div class="ais-hit--picture-wrapper">
         <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${canonicalLink(hit)}"
            >
            <img
              class="ais-hit--picture"
              src="${algoliaShopify.helpers.mediumImage(hit)}"
              alt="${plpTitle(hit)}"
            />
          </a>
        </div>
        <div class="ais-hit--details">
          <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${canonicalLink(hit)}"
            >
              <p class="ais-hit--title">
                ${hit.vendor}
              </p>
              <p class="ais-hit--title-model">
                  ${plpTitleModel(hit)}
              </p>
              <p class="ais-hit--subtitle" title="${plpTitle(hit)}">
                 ${plpTitleColour(hit)}
              </p>
              <div class="ais-hit--price-container">
              ${ hitPriceData.display_compare_at_price ?
                  html`<p class="ais-hit--price-striked">${hitPriceData.display_compare_at_price_formatted}</p>
                       <p class="${hitPriceData.catalog_price ? html`ais-hit--b2b-price`: html`ais-hit--sale-price`}">${hitPriceData.display_price_formatted}</p>`
                : html`<p class="${hitPriceData.catalog_price ? html`ais-hit--b2b-price`: html`ais-hit--price`}">${hitPriceData.display_price_formatted}</p>` 
              }
              </div>
              ${algoliaShopify.b2b && hitPriceData.display_compare_at_price && html`
                  <p class="ais-hit--margin"> Margin: ${hitPriceData.margin_formatted}</p>
                `
              }
            
              <div data-oke-star-rating="" data-oke-reviews-product-id="" data-oke-rendered="" style="display:flex;padding-left: 0.7rem;">
                <div data-oke-reviews-version="0.54.0" data-oke-container="" class="okeReviews oke-sr">
                  <div class="oke-sr-container" style="line-height: 25px; height:25px">
                    ${has_rating && html`
                    <div class="oke-sr-stars">
                      <div class="oke-stars">
                        <div class="oke-stars-background">
                          <svg height="13" viewBox="0 0 79.22222222222221 14" aria-hidden="true">
                            <use x="0" href="#oke-star-empty"></use>
                            <use x="16.155555555555555" href="#oke-star-empty"></use>
                            <use x="32.31111111111111" href="#oke-star-empty"></use>
                            <use x="48.46666666666667" href="#oke-star-empty"></use>
                            <use x="64.62222222222222" href="#oke-star-empty"></use>
                          </svg>
                        </div>
                         <div class="oke-stars-foreground" style="width: ${reviewRatingPercent(hit)}%;">
                          <svg height="13" viewBox="0 0 79.22222222222221 14" aria-hidden="true">
                            <use x="0" href="#oke-star-filled"></use>
                            <use x="16.155555555555555" href="#oke-star-filled"></use>
                            <use x="32.31111111111111" href="#oke-star-filled"></use>
                            <use x="48.46666666666667" href="#oke-star-filled"></use>
                            <use x="64.62222222222222" href="#oke-star-filled"></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="oke-sr-count">
                      <span class="oke-sr-count-number" style="font-size: 1.2rem;">(${hit.meta.reviews.rating_count})</span>
                    </div>
                    `}
                  </div>
                </div>
              </div>
            
            <p class="ais-hit--badge-container">
                  ${hit.inventory_available > 0 || hit.inventory_policy === 'continue' || hit.product_type === "Gift Cards"?
                      algoliaShopify.b2b ?
                            hitPriceData.clearance && html`<span class="badge color-clearance-badge">Clearance</span>`
                          : displayCustomSalesBadge(hit.meta.product ? hit.meta.product.sale_badge_text : '', hit.meta.product ? hit.meta.product.sale_start_date : '', hit.meta.product ? hit.meta.product.sale_end_date : '') && hit.compare_at_price > hit.price && hit.meta.product.display_both_sale_badges === true ?
                              html`<span class="badge color-{{ settings.sale_badge_color_scheme }}">Sale</span><span class="badge color-custom-sale-badge">${ hit.meta.product.sale_badge_text }</span>`
                              : displayCustomSalesBadge(hit.meta.product ? hit.meta.product.sale_badge_text : '', hit.meta.product ? hit.meta.product.sale_start_date : '', hit.meta.product ? hit.meta.product.sale_end_date : '') ?
                                  html`<span class="badge color-custom-sale-badge">${ hit.meta.product.sale_badge_text }</span>`
                                  : hit.compare_at_price > hit.price && (hit.meta.product.obsolete == true || hit.meta.product.obsolete == 'true') && html`<span class="badge color-clearance-badge">Clearance</span>`
                        : html`<span class="badge color-inverse">${ algoliaShopify.translations.outOfStock }</span>`}
                  ${isNewArrival && html`<span class="badge color-new-arrivals-badge">New</span>`}
                  ${isExclusive && html`<span class="badge color-exclusive-badge">Exclusive</span>`}
                  ${isTeamsPick && html`<span class="badge color-teams-pick-badge">Teams Pick</span>`}
                  ${isBestSeller && html`<span class="badge color-best-seller-badge">Best Seller</span>`}
                  ${customBadges[1] && html`<span class="badge color-custom-badge-1">${customBadges[1]}</span>`}
                  ${customBadges[2] && html`<span class="badge color-custom-badge-2">${customBadges[2]}</span>`}
                  ${customBadges[3] && html`<span class="badge color-custom-badge-3">${customBadges[3]}</span>`}
                  ${customBadges[4] && html`<span class="badge color-custom-badge-4">${customBadges[4]}</span>`}
                  ${customBadges[5] && html`<span class="badge color-custom-badge-5">${customBadges[5]}</span>`}
              </p>
          </a>
        </div>
      </div>`;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function(_defaultTemplate, html) {
    return html`
      <div class="ais-hit-empty">
        <div class="ais-hit-empty--title">
          ${algoliaShopify.translations.noResultFound}
        </div>
        <div class="ais-hit-empty--clears">
          ${algoliaShopify.translations.try} ${' '}
          <a class="ais-hit-empty--clear-filters ais-link">
            ${algoliaShopify.translations.clearFilters} ${' '}
          </a>
          ${algoliaShopify.translations.or} ${' '}
          <a class="ais-hit-empty--clear-input ais-link">
            ${algoliaShopify.translations.changeInput}
          </a>
        </div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function(params, facet) {
    if (facet.type === 'conjunctive' || facet.type === 'disjunctive') {
      return {
        ...params,
        limit: 10,
        showMore: true,
        showMoreLimit: 1000,
        searchable: false,
        sortBy: ["isRefined", "name:asc"],
        transformItems(items) {

          if (items.length == 1 && facet.name != 'named_tags.On Sale'  && !items[0].isRefined) {
            return [];  // Refinement list will not render if no items
          }

          const cleanText = (text) => text.replace(/[\[\]\"]/g, '');
          
          if (facet.name === 'named_tags.PDP|PLP|Size') {
            const baseSizes = [
              "2XS", "XXS", "XS", "XS-20", "XS-28", "XS/S", "XS-S", "S", "S-22", "S-28", "S-30", "S-31", "S/M", "S-M", "M", "M-24", "M-32", "M-33", "M-34", "M - Regular", "M/L", "M-L", "L", "L-26", "L-34", "L - Regular", "L - Slim", "L/XL", "L-XL", "XL", "XL-28", "XL-34", "XL-36", "XL/2XL", "XL-2XL", "2XL", "2XL-38", "XXL", "3XL", "3XL-40", "XXXL", "4XL", "XXXXL", 
              "XS - 122mm","S - 126mm","M - 133mm","L - 122mm","L - 134mm","L - 135mm","XL - 137mm","XL - 138mm",
              "One Size Fits Most", "OSFA",
              "3", "4", "5", "5.0", "5.5", "6", "6.0", "6.5", "7", "7.0", "7.5", "8", "8.0", "8.5", "9", "9.0", "9.5", "10", "10.0",  "10C", "10.5", "11", "11.0", "11.5", "12", "12.0", "12.5", "13", "13.0", "13.5", "14", "14.0", "14.5", "15", "15.0",
              "8-10", "10-13"
            ];

            const sizeOrder = [
              ...baseSizes,
              ...baseSizes.map(size => `Women's ${size}`),
              ...baseSizes.map(size => `Youth ${size}`),
              ...baseSizes.map(size => `Youth - ${size}`),
              ...baseSizes.map(size => `Kids ${size}`),
              ...baseSizes.map(size => `US ${size}`),
              ...baseSizes.map(size => `Child ${size}`),
              ...baseSizes.map(size => `Toddler ${size}`),
              ...baseSizes.map(size => `Women's US ${size}`),
            ];

            const parseSizeInML = (label) => {
              const cleaned = label.toLowerCase();

              // 1L = 1000ml
              const litreMatch = cleaned.match(/(\d+(?:\.\d+)?)\s*l\b/);
              if (litreMatch) return parseFloat(litreMatch[1]) * 1000;

              // ml (100ml, 120ml Bottle, etc.)
              const mlMatch = cleaned.match(/(\d+(?:\.\d+)?)\s*ml\b/);
              if (mlMatch) return parseFloat(mlMatch[1]);

              // g or gm (weight treated same as ml for size sorting purposes)
              const gramMatch = cleaned.match(/(\d+(?:\.\d+)?)\s*(g|gm|gms|gram|grams)\b/);
              if (gramMatch) return parseFloat(gramMatch[1]);

              return Number.POSITIVE_INFINITY;
            };

            return items
              .map(item => ({
                ...item,
                label: cleanText(item.label),
                highlighted: cleanText(item.highlighted),
                indexInList: sizeOrder.indexOf(cleanText(item.label)),
                litres: parseSizeInML(cleanText(item.label))
              }))
              .sort((a, b) => {
                const { indexInList: ia, litres: la } = a;
                const { indexInList: ib, litres: lb } = b;

                if (ia !== -1 && ib !== -1) return ia - ib;
                if (ia !== -1) return -1;
                if (ib !== -1) return 1;

                if (la !== lb) return la - lb;

                return a.label.localeCompare(b.label);
              })
              .map(({ indexInList, litres, ...rest }) => rest); // clean up
          }

          if (facet.name === 'named_tags.PDP|PLP|Pedal Size') {
            const pedalSizeOrder = ['Standard', 'S', 'L'];

            return items
              .map(item => ({
                ...item,
                label: cleanText(item.label),
                highlighted: cleanText(item.highlighted),
                sortIndex: pedalSizeOrder.indexOf(cleanText(item.label)),
              }))
              .sort((a, b) => {
                const indexA = a.sortIndex;
                const indexB = b.sortIndex;

                if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                if (indexA !== -1) return -1;
                if (indexB !== -1) return 1;

                return a.label.localeCompare(b.label); // fallback for unknown values
              })
              .map(({ sortIndex, ...rest }) => rest); // remove helper field
          }

          if (facet.name === 'named_tags.PDP|PLP|Lumens') {
            return items
              .map(item => ({
                ...item,
                label: cleanText(item.label),
                highlighted: cleanText(item.highlighted),
                lumenValue: parseFloat(cleanText(item.label)) || Number.POSITIVE_INFINITY
              }))
              .sort((a, b) => a.lumenValue - b.lumenValue)
              .map(({ lumenValue, ...rest }) => rest); // remove helper property
          }

          if (facet.name === 'named_tags.PDP|PLP|Width' ||
              facet.name === 'named_tags.PDP|PLP|Diameter' ||
              facet.name === 'named_tags.PDP|PLP|Outer Diameter' ||
              facet.name === 'named_tags.PDP|PLP|Inner Diameter' ||
              facet.name === 'named_tags.PDP|PLP|Internal Rim Width' ||
              facet.name === 'named_tags.PDP|PLP|Length of Drop' ||
              facet.name === 'named_tags.PDP|PLP|Stem Rise' ||
              facet.name === 'named_tags.PDP|PLP|Rise' ||
              facet.name === 'named_tags.PDP|PLP|Hose Length' ||
              facet.name === 'named_tags.PDP|PLP|Chainring Fitment' ||
              facet.name === 'named_tags.PDP|PLP|Chainline Offset' ||
              facet.name === 'named_tags.PDP|PLP|Chain Speeds' ||
              facet.name === 'named_tags.PDP|PLP|Speeds') 
          {
            const parseFacetVales = (label) => {
              const cleaned = label.trim().toLowerCase();

              // Improved patterns
              const inchPattern = /([\d.]+)(?:\s*[-/]\s*([\d.]+))?\s*inch\b/i;
              const mmRisePattern = /([\d.]+)(?:\s*[-/]\s*([\d.]+))?\s*rise\s*mm\b/i;
              const mmDropPattern = /([\d.]+)(?:\s*[-/]\s*([\d.]+))?\s*drop\s*mm\b/i;
              const mmPattern = /([\d.]+)(?:\s*[-/]\s*([\d.]+))?\s*mm\b/i;
              const cPattern = /([\d.]+)(?:\s*[-/]\s*([\d.]+))?\s*c\b/i;
              const dropPattern = /([\d.]+)(?:\s*[-/]\s*([\d.]+))?\s*drop\b/i;
              const degreePattern = /([\d.]+)(?:\s*[-/]\s*([\d.]+))?\s*degree\b/i;
              const risePattern = /([\d.]+)(?:\s*[-/]\s*([\d.]+))?\s*rise\b/i;
              const bcdPattern = /([\d.]+)(?:\s*[-/]\s*([\d.]+))?\s*bcd\b/i;
              const chainSpeedsPattern = /([\d.]+)(?:\s*[-/]\s*([\d.]+))?\s*speed\b/i;

              const toMM = (inches) => parseFloat(inches) * 25.4;

              const parseRange = (match, unitConverter = (v) => parseFloat(v)) => {
                const start = unitConverter(match[1]);
                const end = match[2] ? unitConverter(match[2]) : start;
                return (start + end) / 2;
              };

              if (inchPattern.test(cleaned)) return parseRange(cleaned.match(inchPattern), toMM);
              if (mmRisePattern.test(cleaned)) return parseRange(cleaned.match(mmRisePattern));
              if (mmDropPattern.test(cleaned)) return parseRange(cleaned.match(mmDropPattern));
              if (mmPattern.test(cleaned)) return parseRange(cleaned.match(mmPattern));
              if (cPattern.test(cleaned)) return parseRange(cleaned.match(cPattern)); // treat C as mm equivalent
              if (dropPattern.test(cleaned)) return parseRange(cleaned.match(dropPattern));
              if (degreePattern.test(cleaned)) return parseRange(cleaned.match(degreePattern));
              if (risePattern.test(cleaned)) return parseRange(cleaned.match(risePattern));
              if (bcdPattern.test(cleaned)) return parseRange(cleaned.match(bcdPattern));
              if (chainSpeedsPattern.test(cleaned)) return parseRange(cleaned.match(chainSpeedsPattern));


              // ✅ NEW: Loose mm fallback — captures first mm value anywhere
              const looseMM = cleaned.match(/(\d+(?:\.\d+)?)\s*mm/);
              if (looseMM) return parseFloat(looseMM[1]);

              // fallback for pure numbers (assume mm)
              const numericOnly = cleaned.match(/^([\d.]+)$/);
              if (numericOnly) return parseFloat(numericOnly[1]);

              return Number.POSITIVE_INFINITY; // sort unknowns to the end
            };


            return items
              .map(item => ({
                ...item,
                label: cleanText(item.label),
                highlighted: cleanText(item.highlighted),
                widthValue: parseFacetVales(cleanText(item.label))
              }))
              .sort((a, b) => a.widthValue - b.widthValue);
          }

          return items.map(item => ({
            ...item,
            label: cleanText(item.label),
            highlighted: cleanText(item.highlighted),
          }));
        },
        templates: {
          item(item, { html }) {
            return html`
              <label class="${item.cssClasses.label}">
                ${facet.type === 'disjunctive' &&
                  (item.isRefined
                    ? html`
                        <input
                          type="checkbox"
                          class="${item.cssClasses.checkbox}"
                          checked
                        />
                      `
                    : html`
                        <input type="checkbox" class="${item.cssClasses.checkbox}" />
                      `)}
                ${item.label}
              </label>
            `;
          },
        },
      }
    }

    if (facet.type == "slider") {
      return {
        ...params,
        pips: true,
        tooltips: true,
      }
    }

    return {
      ...params,
      limit: 1000,
      showMore: false,
      searchable: false,
    }
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function (_defaultTemplate, data, html) {
    return html`
      ${data.query &&
        html`
          <div class="ais-search-header-query">
            Search results for <span class="ais-stats--nb-results">"${data.query}"</span>
          </div>
        `}
      <span class="ais-stats--nb-results">
        ${data.hasOneResult 
          ? '1 product' 
          : `${algoliaShopify.helpers.formatNumber(data.nbHits)} products`}
      </span>
    `;
  });

  algoliaShopify.hooks.registerHook("beforeISStartAddWidgetArray", function () {
    const { configure } = window.algoliaShopify.externals.widgets;
    configureWidget = configure({
      facetingAfterDistinct: false,
    });
    return [configureWidget];
  });

  algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function(defaultWidgets) {
    const defaultStatsWidget = defaultWidgets.find(
      widget => widget.$$widgetType === 'ais.stats'
    );

    return [defaultStatsWidget];
  });

  function openCloseModalFacets() {
    const facets = document.querySelector(".ais-facets");
    const isShown = facets.classList.toggle("ais-facets__shown");
  
    if (isShown) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden"; // <html>
      document.body.style.position = "fixed"; // prevents rubber-band scroll
      document.body.style.width = "100%";
      requestAnimationFrame(() => {
        document.querySelector(".ais-facets").scrollTop = 0;
      });
    } else {
      const filterCount = document.querySelectorAll('.ais-current-refined-values--item').length;
      const filtertext = document.querySelector(".ais-button-filter-text"); 
      filtertext.innerText = filterCount > 0 ? `Filters (${filterCount})` : "Filters";

      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    }
  }
  
  function toggleSortDropdown() {
    const dropdown = document.querySelector(".ais-sort-dropdown");
    const chevron = document.querySelector(".sort-chevron");
  
    const isOpen = !dropdown.hasAttribute("hidden");
  
    if (isOpen) {
      dropdown.setAttribute("hidden", "");
      chevron.classList.remove("rotated");
    } else {
      dropdown.removeAttribute("hidden");
      chevron.classList.add("rotated");
    }
  }
  
  function sortOptionClicked(sortOptionValue) {
    const sortBySelect = document.querySelector(".ais-SortBy-select");
    if (sortBySelect) {
      sortBySelect.value = sortOptionValue;
      
      const sortByText = document.querySelector(".ais-button-sortby-text");
      if (sortByText) {
        const selectedOption = Array.from(sortBySelect.options).find(option => option.value === sortOptionValue);
        if (selectedOption) {
          sortByText.innerText = selectedOption.text;

          const event = new Event("change", { bubbles: true });
          sortBySelect.dispatchEvent(event);
        }
      }
    }

    toggleSortDropdown();
  }
  
  
});

// ***************************************************************
// ***                 Product Finder Tile Display             ***
// ***************************************************************
function bannerLI() {
  if (window.collectionProductFinderImageURL && window.collectionProductFinderImageURL.trim() !== '') {
    console.log('Product Finder Tile Display: Adding banner tile');
    const bannerLI = document.createElement('li');
    bannerLI.className = 'ais-Hits-item product-finder-tile';
    bannerLI.innerHTML = `
      <div class="product-finder-banner">
        <div class="product-finder-banner-overlay">
          <a href="/pages/${window.collectionProductFinderPage}" class="product-finder-banner-link">
            <img src="${window.collectionProductFinderImageURL}" class="product-finder-banner-image" />
          </a>
        </div>
      </div>
    `;
    return bannerLI;
  }
  else {
    return null;
  }
}

function observeHitsListChanges(hitsList) {
  const manageBannerPlacement = () => {
    const allItems = hitsList.querySelectorAll('li');
    const banner = hitsList.querySelector('.product-finder-tile');
    const count = allItems.length;

    if (!banner) {
      const newBanner = bannerLI();
      if (!newBanner) return; // No banner to add
      
      if (count >= 5) {
        allItems[4].before(newBanner);
      } else {
        hitsList.appendChild(newBanner);
      }
    } else {
      // Banner exists — ensure it’s in the correct position
      const itemsArray = Array.from(hitsList.children);
      const bannerIndex = itemsArray.indexOf(banner);

      if (count >= 5 && bannerIndex !== 4) {
        hitsList.removeChild(banner);
        hitsList.insertBefore(banner, allItems[4]);
      } else if (count < 5 && bannerIndex !== count - 1) {
        hitsList.removeChild(banner);
        hitsList.appendChild(banner);
      }
    }
  };

  // Initial run
  manageBannerPlacement();

  const observer = new MutationObserver(() => {
    manageBannerPlacement();
  });

  observer.observe(hitsList, {
    childList: true,
    subtree: false,
  });
}

function waitForHitsListAndObserve() {
  const hitsList = document.querySelector('.ais-Hits-list');

  if (hitsList) {
    observeHitsListChanges(hitsList);
  } else {
    const interval = setInterval(() => {
      const list = document.querySelector('.ais-Hits-list');
      if (list) {
        clearInterval(interval);
        observeHitsListChanges(list);
      }
    }, 200);
  }
}

// Start the watcher
if (window.collectionProductFinderPage) {
  waitForHitsListAndObserve();
};

// ***************************************************************
// ***                      Helper Functions                   ***
// ***************************************************************

function productCatalog(hit){
  if (hit.meta.product.wholesale_prices){
    const catalogs = JSON.parse(hit.meta.product.wholesale_prices);
    const foundCatalog = catalogs.find(priceInfo => priceInfo.catalog === algoliaShopify.catalog);

    if (foundCatalog) {
      return foundCatalog;
    } else {
      return null;
    }
  }
  else {
    return null;
  } 
};
function formatPrice(value) {
  return algoliaShopify.formatMoney(Number(value) * 100);
};
function formatPercentage(decimal) {
  // Ensure the input is a number
  if (typeof decimal !== 'number') {
      throw new Error('Input must be a number');
  }

  // Multiply by 100 to convert to percentage
  let percentage = decimal * 100;

  // Format the number to two decimal places
  percentage = percentage.toFixed(2);

  // Append the percentage symbol and return the result
  return percentage + '%';
};
function reviewRatingPercent(item) {
  var res = 0;

  if (item.meta && item.meta.reviews && item.meta.reviews.rating) {
    var ratingParsed = JSON.parse(item.meta.reviews.rating);
    var rating = ratingParsed.value;
    var scaleMax = ratingParsed.scale_max;
    res = (rating / scaleMax) * 100;
  }

  return res;
};
function priceData(hit) {
  const catalog = productCatalog(hit);
  var priceData = {};
  if (catalog) {
    priceData = {
      catalog_price: true,
      price:  catalog.price ? catalog.price : null, 
      display_price_formatted: '',
      compare_at_price: hit.meta.product.b2b_margin_base_price ? hit.meta.product.b2b_margin_base_price : null,
      display_compare_at_price_formatted: '',
      margin: 0.00,
      margin_formatted: '',
      minimum_price: catalog.min_price ? catalog.min_price : null,
      maximum_price: catalog.max_price ? catalog.max_price : null,
      clearance: catalog.clearance ? catalog.clearance : false 
    };
  }
  else{
    priceData = {
      catalog_price: false, 
      price: hit.price, 
      display_price_formatted: '',
      compare_at_price: hit.compare_at_price,
      display_compare_at_price_formatted: '',
      margin: 0.00,
      margin_formatted: '',
      minimum_price: hit.meta.product.minimum_price,
      maximum_price: hit.meta.product.maximum_price,
      clearance: false
    };
  }
  
  priceData.display_compare_at_price = (priceData.minimum_price != priceData.maximum_price 
    ? false 
    : (priceData.compare_at_price > priceData.maximum_price 
        ? (priceData.compare_at_price - priceData.maximum_price) < 0.06 
          ? false 
          : true 
        : false));        
  if (priceData.display_compare_at_price) {
    priceData.margin = (priceData.compare_at_price - priceData.price)/priceData.compare_at_price;
    priceData.margin_formatted = formatPercentage(priceData.margin);
  }
  priceData.display_compare_at_price_formatted = formatPrice(priceData.compare_at_price);

  if (priceData.minimum_price != priceData.maximum_price) {
    priceData.display_price_formatted = formatPrice(priceData.minimum_price) + ' - ' + formatPrice(priceData.maximum_price);
  }
  else {
    priceData.display_price_formatted = formatPrice(priceData.price);
  }
  
  return priceData;
};
function displayCustomSalesBadge(saleBadgeText, saleStartDate, saleEndDate){
  var todayDate = new Date();
  if (saleStartDate){
    saleStartDate = new Date(saleStartDate);
  } else {
    return false
  }
  if (saleEndDate){
    saleEndDate = new Date(saleEndDate);
  } else {
    return false
  }

  return ( todayDate >= saleStartDate && todayDate <= saleEndDate && saleBadgeText )
}
function plpTitle(hit) {
  var res = hit.title;
  if (hit.meta && hit.meta.product && hit.meta.product.plp_title) {
    res = hit.meta.product.plp_title;
  } else if (
    !hit._distinct &&
    hit.variant_title &&
    hit.variant_title !== 'Default Title' &&
    hit.variant_title !== 'Default'
  ) {
    res += ' (' + hit.variant_title + ')';
  }

  return res;
};
function plpTitleModel(hit) {
  var res = hit.title;
  if (hit.meta && hit.meta.product && hit.meta.product.plp_title) {

    //Remove the colour section from the PLP title
    const parts = hit.meta.product.plp_title.split(' - '); // Split the text into an array using ' - ' as the separator
    res = parts[0]; // Get the first part of the array

    //Remove Vendor from the plp title
    const regex = new RegExp(hit.vendor, "i");
    res = res.replace(regex, "");

  } else if (
    !hit._distinct &&
    hit.variant_title &&
    hit.variant_title !== 'Default Title' &&
    hit.variant_title !== 'Default'
  ) {
    res += ' (' + hit.variant_title + ')';
  }
  res = res.trim();
  return res.trim();
};
function plpTitleColour(hit) {
  var res = hit.title;
  if (hit.meta && hit.meta.product && hit.meta.product.plp_title) {

    //Return the colour section from the PLP title
    const parts = hit.meta.product.plp_title.split(' - '); // Split the text into an array using ' - ' as the separator
    res = parts.slice(1).join(' - '); //parts[1]; // Get the first part of the array
  } else if (
    !hit._distinct &&
    hit.variant_title &&
    hit.variant_title !== 'Default Title' &&
    hit.variant_title !== 'Default'
  ) {
    res += ' (' + hit.variant_title + ')';
  }

  return res;
};
function canonicalHandle(hit) {
  var res = hit.handle;

  if (hit.meta && hit.meta.product && hit.meta.product.canonical) {
    res = hit.meta.product.canonical;
  }

  return res;
};
function canonicalLink(hit) {
  const addVariantId = hit.objectID !== hit.id;
  var handle = hit.handle;

  if (hit.meta && hit.meta.product && hit.meta.product.canonical) {
    handle = hit.meta.product.canonical;
  }

  return (
    '/products/' +
    handle +
    (addVariantId ? '?variant=' + hit.objectID : '')
  );
};
